import { useState } from "react";
import type { GridSortModel } from "@mui/x-data-grid";
import { isSortDirection } from "../utils/isSortDirection";
import useQueryParams from "./useQueryParams";

interface UseSortingModel {
  sortModel: GridSortModel;
  setSortModel: (model: GridSortModel) => void;
}

type UseSortingProps = {
  initialSortModel?: GridSortModel;
};

function useSorting(props?: UseSortingProps): UseSortingModel {
  const [parameters, setParameters] = useQueryParams({ paramKeys: ["field", "sort"] });

  const { initialSortModel = [] } = props ?? {};

  const initialSortParameters =
    parameters.field && parameters.sort
      ? [
          {
            field: parameters.field,
            sort: isSortDirection(parameters.sort) ? parameters.sort : undefined,
          },
        ]
      : initialSortModel;

  const [sortModel, setSortModelState] = useState(initialSortParameters);

  const setSortModel = (model: GridSortModel) => {
    setSortModelState(model);
    setParameters({ field: model[0]?.field, sort: model[0]?.sort });
  };

  return {
    sortModel,
    setSortModel,
  };
}

export default useSorting;
